module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG1004-b22e2837689b065fe5ddd0dbd9c7a991.png";